import React from "react";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import BackgroundWrapper from "../components/BackgroundWrapper";

export default function Home() {
  return (
     <BackgroundWrapper>
         <div className="pt-8 pb-20 px-4 min-h-screen flex justify-center flex items-center">
         <div className="max-w-4xl mx-auto bg-white/90 backdrop-blur-md rounded-3xl shadow-2xl p-10 md:p-16 text-center">
           
      <div className="max-w-7xl mx-auto text-center w-full">

        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-slate-800 mb-4 sm:mb-6 leading-tight">
          Moving Leaders and <br />
          <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
            Organizations
          </span> <br />
          From Success to Significance
        </h2>
        <p className="text-base sm:text-lg md:text-xl text-slate-700 mb-8 sm:mb-10 max-w-3xl mx-auto px-2">
          Developing enlightened leaders and effective organizations in transformational states,
          going beyond what business schools and tools have to offer.
        </p>
        <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-3 sm:gap-4">
          <Link to="/who-we-are" className="bg-white/90 text-blue-600 px-6 sm:px-8 py-3 sm:py-4 rounded-full font-semibold border-2 border-blue-600 hover:shadow-xl transition text-sm sm:text-base inline-flex items-center justify-center">
            Who We Are <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5 ml-2" />
          </Link>
          <Link to="/what-we-do" className="bg-white/90 text-indigo-600 px-6 sm:px-8 py-3 sm:py-4 rounded-full font-semibold border-2 border-indigo-600 hover:shadow-xl transition text-sm sm:text-base inline-flex items-center justify-center">
            What We Do <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5 ml-2" />
          </Link>
          <Link to="/programs" className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-semibold hover:shadow-2xl transition text-sm sm:text-base inline-flex items-center justify-center">
            Our Programs <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5 ml-2" />
          </Link>
          <Link to="/contact" className="bg-white/90 text-slate-700 px-6 sm:px-8 py-3 sm:py-4 rounded-full font-semibold border-2 border-slate-700 hover:shadow-xl transition text-sm sm:text-base inline-flex items-center justify-center">
            Contact Us <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5 ml-2" />
          </Link>
        </div>
      </div>
    </div>
    </div>
   </BackgroundWrapper>
  );
}